module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLight.00ad294.eot";